import React from 'react'
import Header from './Header'
import Footer from './Footer'

import { createWeb3Modal } from '@web3modal/ethers/react'
import { ethersConfig, network, projectId } from '../config'

function Layout({ children }) {

  createWeb3Modal({
    ethersConfig: ethersConfig,
    chains: [network],
    projectId: projectId,
    enableAnalytics: true
  })

  return (
    <>
      <Header />
      <div>
        {children}
      </div>
      <Footer />
    </>
  )
}

export default Layout